import {
  Separator,
  Shimmer,
  ShimmerElementsGroup,
  ShimmerElementType,
  Stack,
} from '@fluentui/react';
import React, { JSX } from 'react';
import { useStyles } from './index.styles';

export const ShimmerSection1 = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.fullWidthContainer}>
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 40, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 30, width: '100%' },
        ]}
      />
    </div>
  );
};

export const ShimmerSection2 = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.fullWidthContainer}>
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 50, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '10%' },
          { type: ShimmerElementType.gap, height: 20, width: '3%' },
          { type: ShimmerElementType.line, height: 20, width: '10%' },
          { type: ShimmerElementType.gap, height: 20, width: '77%' },
        ]}
      />

      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 50, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
        ]}
      />

      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 20, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
        ]}
      />

      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 20, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
        ]}
      />

      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 20, width: '100%' },
        ]}
      />
    </div>
  );
};

export const ShimmerView: React.FC = () => {
  const styles = useStyles();
  return (
    <React.Fragment>
      <Separator />
      <Stack className={styles.containerpadding}>
        <Shimmer customElementsGroup={ShimmerSection1()} />
        <Shimmer customElementsGroup={ShimmerSection1()} />
        <Shimmer customElementsGroup={ShimmerSection1()} />
        <Shimmer customElementsGroup={ShimmerSection1()} />
        <Shimmer customElementsGroup={ShimmerSection1()} />
        <Shimmer customElementsGroup={ShimmerSection1()} />
      </Stack>
    </React.Fragment>
  );
};
